<template>
  <div class="animated revealUp">
    <div class="d-flex justify-content-between align-item-center mb-3">
      <div class="section-title">{{ $t('view') }} {{ $t('concession') }}</div>
      <div>
        <router-link
          class="btn-blue"
          @click.native="goToRoute('/cinema-manager/edit-concession', concession_level_id)"
          to
        >{{ $t('edit') }}</router-link>
        <router-link class="btn-blue" to="concession">{{ $t('concession') }} {{ $tc('list', 1) }}</router-link>
      </div>
    </div>

    <div class="all-details-container">
      <div class="col-md-12">
        <div>
          <div class="row border-bottom py-2">
            <div class="col-lg-3">{{ $tc('concession') }} {{ $t('name') }}</div>
            <div class="col-lg-9">{{ concession_details.cl_name }}</div>
          </div>
          <div class="row border-bottom py-2">
            <div class="col-lg-3">{{ $tc('status', 1)}}</div>
            <div
              class="col-lg-9"
            >{{ concession_details.cl_is_active == 'Y' ? 'Active' : 'Inactive' }}</div>
          </div>
          <div v-if="GetRoleId && GetRoleId === 1" class="row border-bottom py-2">
            <div class="col-lg-3">{{ $t('createdby')}}</div>
            <div class="col-lg-9">{{ concession_details.created_by }}</div>
          </div>
          <div v-if="GetRoleId && GetRoleId === 1" class="row border-bottom py-2">
            <div class="col-lg-3">{{ $t('createdat')}}</div>
            <div class="col-lg-9">{{ concession_details.created_at | dateparse }}</div>
          </div>
          <div v-if="GetRoleId && GetRoleId === 1" class="row border-bottom py-2">
            <div class="col-lg-3">{{ $t('updatedby')}}</div>
            <div class="col-lg-9">{{ concession_details.updated_at | dateparse }}</div>
          </div>
          <div v-if="GetRoleId && GetRoleId === 1" class="row border-bottom py-2">
            <div class="col-lg-3">{{ $t('updatedat')}}</div>
            <div class="col-lg-9">{{ concession_details.updated_by }}</div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import MasterService from "@/services/MasterService.js";
export default {
  data() {
    return {
      concession_details: {
        created_by: null,
        created_at: null,
        updated_by: null,
        updated_at: null
      },
      item: {},
      concession_level_id: null
    };
  },
  beforeMount() {
    const { id } = this.$route.query;
    this.concession_level_id = id;
  },
  mounted() {
    this.getConcessionDetails();
  },
  methods: {
    goToRoute: function(path, item) {
      const { cl_id } = item;
      this.$router.push({
        path: path,
        query: {
          id: this.concession_level_id
        }
      });
    },
    getConcessionDetails() {
      let payload = {
        tableName: "ms_concession_levels",
        cl_id: this.concession_level_id
      };
      MasterService.GetActiveList(payload)
        .then(response => {
          const { data } = response;
          if (data.status && data.Records.length > 0) {
            this.concession_details = data.Records[0];
            let obj = data.Records[0];
            Object.keys(this.concession_details).map((x, index) => {
              if (x === "created_by") {
                this.getViewUsersDetails(
                  obj[x],
                  "created_by",
                  "concession_details"
                );
              } else if (x === "updated_by") {
                this.getViewUsersDetails(
                  obj[x],
                  "updated_by",
                  "concession_details"
                );
              }
            });
          } else {
            console.log("show error :", data.message);
          }
        })
        .catch(this._CatchError);
    },
    getViewUsersDetails(user_id, fieldvalue, key) {
      this[key][fieldvalue] = "-";
      if (user_id) {
        MasterService.GetUserInfoById({ user_id })
          .then(response => {
            const { data } = response;
            if (data && data.status && data.Records.length > 0) {
              this[key][fieldvalue] = data.Records[0].user_name;
            } else {
              // Error Message
              console.log("data.message :", data.message);
            }
          })
          .catch(error => {
            // Catch Error
            console.log("Catch Error on getViewUsersDetails :", error);
          });
      }
    }
  }
};
</script>


// WEBPACK FOOTER //
// src/components/Pages/ExhibitorManagement/ConcessionComponents/viewConcession.vue